// This script ensures the bottom navigation bar is always shown on vendor pages
import { useEffect } from 'react';

export const useEnsureBottomNavVisibility = () => {
  useEffect(() => {
    // Force the navigation to be visible
    const navElement = document.querySelector('.vendor-bottom-nav');
    if (navElement) {
      // Ensure it has the highest z-index
      navElement.setAttribute('style', 'position: fixed !important; bottom: 0 !important; left: 0 !important; width: 100% !important; z-index: 9999 !important; display: flex !important;');
    }

    // Add additional padding to the body
    document.body.classList.add('has-bottom-nav');

    return () => {
      document.body.classList.remove('has-bottom-nav');
    };
  }, []);
};
